import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_COURSE_TYPE_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_COURSE_TYPE } from '../redux/action-types'

const useSetIsCurationEnabledCourseTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.courseTypes.courseTypes,
  )

  const mutate = useCallback(
    async (id, isCurationEnabled) => {
      await apolloService.mutate(
        SET_IS_CURATION_ENABLED_COURSE_TYPE_MUTATION,
        {
          id,
          isCurationEnabled,
        },
        dispatch,
        SET_IS_CURATION_ENABLED_COURSE_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSetIsCurationEnabledCourseTypeMutation
